import { FiGift } from 'react-icons/fi';
import './Account.css';

export default function AccountBonuses() {
  return (
    <div className="account-stack">
      <section className="account-card account-bonus-hero account-bonus-hero--paused">
        <div className="account-bonus-hero__icon" aria-hidden>
          <FiGift />
        </div>
        <div>
          <p className="account-bonus-hero__label">Бонусная программа</p>
          <p className="account-bonus-hero__value">Пока недоступна</p>
          <p className="account-card__hint">
            Начисление и списание бонусов временно отключены. Когда программа снова заработает,
            баланс и история появятся здесь.
          </p>
        </div>
      </section>
    </div>
  );
}
